import { render, staticRenderFns } from "./SubEmpresaVisualizarProcessamentoContrato.vue?vue&type=template&id=bf144b52&lang=pug"
import script from "./SubEmpresaVisualizarProcessamentoContrato.vue?vue&type=script&lang=js"
export * from "./SubEmpresaVisualizarProcessamentoContrato.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaVisualizarProcessamentoContrato.vue?vue&type=style&index=0&id=bf144b52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports